module.exports = __webpack_public_path__ + "static/media/home_logo2.cf3a17ee.png";